export default __webpack_public_path__ + "static/media/titulo.0b350ade.png";